
export default {
    name: 'BaseTag',

    props: {
        variant: {
            type: String,
            default: 'infogrey',
            validator: function (value) {
                return [
                    'red',
                    'gold',
                    'orange',
                    'cerulean',
                    'olive',

                    'success',
                    'info',
                    'warning',
                    'error',
                    'disabled',
                ].includes(value)
            },
        },
        tooltipText: {
            type: String,
            default: null,
        },
    },

    data() {
        return {
            variants: {
                red: {
                    backgroundColor: 'bg-red-light',
                    textColor: 'text-red',
                    borderColor: 'border-red',
                },
                gold: {
                    backgroundColor: 'bg-gold-light',
                    textColor: 'text-gold',
                    borderColor: 'border-gold',
                },
                orange: {
                    backgroundColor: 'bg-orange-light',
                    textColor: 'text-orange',
                    borderColor: 'border-orange',
                },
                cerulean: {
                    backgroundColor: 'bg-cerulean-light',
                    textColor: 'text-cerulean',
                    borderColor: 'border-cerulean',
                },
                olive: {
                    backgroundColor: 'bg-olive-light',
                    textColor: 'text-olive',
                    borderColor: 'border-olive',
                },

                // New colors
                success: {
                    backgroundColor: 'bg-utility-success-lighter',
                    textColor: 'text-utility-success',
                    borderColor: 'text-utility-success',
                },
                info: {
                    backgroundColor: 'bg-utility-info-lighter',
                    textColor: 'text-utility-info',
                    borderColor: 'text-utility-info',
                },
                warning: {
                    backgroundColor: 'bg-utility-warning-lighter',
                    textColor: 'text-utility-warning',
                    borderColor: 'text-utility-warning',
                },
                error: {
                    backgroundColor: 'bg-utility-error-lighter',
                    textColor: 'text-utility-error',
                    borderColor: 'text-utility-error',
                },
                disabled: {
                    backgroundColor: 'bg-[#F7F7F7]',
                    textColor: 'text-[#ABABAB]',
                    borderColor: 'text-[#ABABAB]',
                },
            },
        }
    },

    computed: {
        backgroundColor() {
            return this.variants[this.variant].backgroundColor
        },
        textColor() {
            return this.variants[this.variant].textColor
        },
        borderColor() {
            return this.variants[this.variant].borderColor
        },
    },
}
